import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { createVisualizationIconUrl } from './shapeSvg';
import { VisualizationStyle } from './types';

interface VisualizationSymbolProps {
  style: VisualizationStyle;
  maxSize?: number;
  sizeMultiplier?: number;
}

export const VisualizationSymbol = React.memo(
  ({ style, maxSize = 36, sizeMultiplier = 1 }: VisualizationSymbolProps) => {
    const src = useMemo(() => createVisualizationIconUrl(style), [style]);
    const size = Math.min(maxSize, 12 * style.sizeScale) * sizeMultiplier;

    return (
      <Box
        component="img"
        src={src}
        alt={`${style.shape} visualization symbol`}
        width={size}
        height={size}
        flexShrink={0}
      />
    );
  }
);
